import React, { ButtonHTMLAttributes, CSSProperties, ReactElement } from 'react';

export type ButtonColors =
  | 'primary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger'
  | 'default'
  | 'secondary'
  | 'cancel'
  | 'link';

export interface IButtonProps {
  /**
   * The text that appears in the button
   */
  label: string | ReactElement<HTMLElement>;

  /**
   * Type attribute of the button (e.g., submit)
   * @default 'submit'
   */
  type?: ButtonHTMLAttributes<any>['type'];

  /**
   * Either a bootstrap color (primary, success, etc)
   * @default 'default'
   */
  color?: ButtonColors;

  /**
   * Option to disable the button
   * @default false
   */
  disabled?: boolean;

  /**
   * Option to change button sizes
   */
  size?: 'lg' | 'sm' | 'xs';

  /**
   * Option adds a title attribute to the button
   */
  title?: string;

  /**
   * Option to add a url - will change button to an a tag
   */
  href?: string;

  /**
   * Helper attribute for QA. Adds "qa-id" attribute to component's container
   */
  'qa-id'?: string;

  /**
   * Option to add custom styles
   */
  style?: CSSProperties;

  /**
   * Optional click handler to be added to the button
   */
  onClick?(e: React.SyntheticEvent<HTMLButtonElement> | React.SyntheticEvent<HTMLAnchorElement>): void;
}
